import { create } from "zustand";

export interface MiceQuotationRestoreModalState {
  isOpen: boolean;
  companyId: number | null;
  quotationId: string | null;
  open(companyId: number | null, quotationId: string | null): void;
  close(): void;
}

export const useMiceQuotationRestoreModalStore =
  create<MiceQuotationRestoreModalState>((set) => {
    return {
      isOpen: false,
      companyId: null,
      quotationId: null,
      open: (companyId: number | null, quotationId: string | null) =>
        set(() => ({
          isOpen: true,
          companyId,
          quotationId,
        })),

      close: () =>
        set(() => ({
          isOpen: false,
          companyId: null,
          quotationId: null,
        })),
    };
  });
